import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24ForumG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M19.24 6.925A2.435 2.435 0 0 1 21.67 9.2l.005.16v9.68a2.435 2.435 0 0 1-2.275 2.43l-.16.005H8.36A2.435 2.435 0 0 1 5.93 19.2l-.005-.16v-1.203h1.35v1.203c0 .56.423 1.02.967 1.079l.118.006h10.88c.56 0 1.02-.423 1.079-.967l.006-.118V9.36c0-.56-.423-1.02-.967-1.079l-.118-.006h-1.3v-1.35z"
      }), /*#__PURE__*/jsx("path", {
        d: "M15.64 3.325H4.76A2.435 2.435 0 0 0 2.325 5.76v9.68a2.435 2.435 0 0 0 2.435 2.435h10.88a2.435 2.435 0 0 0 2.435-2.435V5.76a2.435 2.435 0 0 0-2.435-2.435M4.76 4.675h10.88c.6 0 1.085.486 1.085 1.085v9.68c0 .6-.486 1.085-1.085 1.085H4.76c-.6 0-1.085-.486-1.085-1.085V5.76c0-.6.486-1.085 1.085-1.085"
      }), /*#__PURE__*/jsx("path", {
        d: "M13.8 8.26a.54.54 0 0 1 .088 1.073l-.088.007H6.6a.54.54 0 0 1-.088-1.073L6.6 8.26zM6.604 11.86l4.838.038a.54.54 0 0 1 .079 1.073l-.088.006-4.837-.037a.54.54 0 0 1-.08-1.074z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24ForumG$1 = Svg24ForumG;

export { Svg24ForumG$1 as default };
